import {
  Box,
  ClickAwayListener,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Popper,
  Typography,
} from '@mui/material';
import { useRef, useState } from 'react';
import NoteDetailDialog from './NoteDetailDialog';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CardNoteDTO from '@src/adapters/dto/card/CardNoteDTO';
import useDeleteCardNoteLazy from '@src/adapters/hooks/card/useDeleteCardNote';

interface Props {
  cardId: string;
  note: CardNoteDTO;
  isEdit: boolean;
  noteUpdated(note: CardNoteDTO): void;
  noteDeleted(noteId: string): void;
}

function Note({ cardId, isEdit, note, noteUpdated, noteDeleted }: Props) {
  const menu = useRef(null);
  const { execute: deleteNote } = useDeleteCardNoteLazy();
  const [editOpen, setEditOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleEditNote = () => {
    setEditOpen(true);
  };

  const handleClose = (note: CardNoteDTO | undefined) => {
    if (note) {
      noteUpdated(note);
    }
    setEditOpen(false);
  };

  const handleDeleteNote = async () => {
    await deleteNote({
      cardId: cardId,
      noteId: note.id,
    }).then((result) => {
      if (result.deleted) {
        noteDeleted(note.id);
        setMenuOpen(false);
      }
    });
  };

  return (
    <>
      <Box
        sx={(theme) => ({
          padding: `${theme.spacing(2.5)} 0 ${theme.spacing(2)} ${theme.spacing(
            2
          )}`,
          borderBottom: '1px solid #E6E7E9',
          display: 'flex',
        })}>
        <Typography
          variant="body1"
          sx={{ whiteSpace: 'pre-line', width: '80%' }}>
          {note.content}
        </Typography>
        <Box>
          {isEdit && (
            <IconButton
              aria-label="logout"
              onClick={() => setMenuOpen((prev) => !prev)}
              size="large"
              ref={menu}>
              <MoreVertIcon />
            </IconButton>
          )}
        </Box>
      </Box>
      <Popper
        open={menuOpen}
        anchorEl={menu.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
        sx={{ zIndex: 1300, pointerEvents: 'auto' }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}>
            <Box sx={{ backgroundColor: 'white', borderRadius: 1 }}>
              <ClickAwayListener
                onClickAway={() => setMenuOpen((prev) => !prev)}>
                <MenuList
                  autoFocusItem={menuOpen}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  sx={{
                    backgroundColor: 'red',
                    border: '1px solid #ccc',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    opacity: '1',
                    background: 'rgb(255, 255, 255)',
                    zIndex: 1300,
                  }}>
                  {/* onKeyDown={handleListKeyDown} */}
                  <MenuItem onClick={handleEditNote} key="edit">
                    Edit
                  </MenuItem>
                  <MenuItem onClick={handleDeleteNote} key="delete">
                    Delete
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Box>
          </Grow>
        )}
      </Popper>
      <NoteDetailDialog
        isOpen={editOpen}
        onClose={handleClose}
        cardId={cardId}
        note={note}
      />
    </>
  );
}

export default Note;
